<template>
  <ez-button-dropdown :data-cy="dataCy" :expandOnClick="true" buttonType="white" show-below>
    <slot></slot>
    <template #dropdown>
      <slot name="dropdown"></slot>

      <div class="dropdown-section">
        <hr />

        <slot name="venueSettings"></slot>

        <slot name="userSettings"></slot>

        <ez-button
          :data-cy="commonCy.ACCOUNT_SETTINGS.BUTTON__LEGAL"
          type="link"
          formType="button"
          isFullWidth
          @click="$router.push({ name: legal })"
        >
          Legal
        </ez-button>
        <ez-button
          :data-cy="commonCy.ACCOUNT_SETTINGS.BUTTON__HELP"
          type="link"
          formType="button"
          isFullWidth
          @click="openHelp"
        >
          Help
        </ez-button>
        <hr />
        <ez-button
          :data-cy="commonCy.ACCOUNT_SETTINGS.BUTTON__SIGN_OUT"
          type="link"
          formType="button"
          customClass="gray-link"
          isFullWidth
          @click="onLogoutClick"
        >
          Sign Out
        </ez-button>
      </div>
    </template>
  </ez-button-dropdown>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import EzButton from '@/components/ui/Button';
import EzButtonDropdown from '@/components/ui/ButtonDropdown';
import { resetState } from '@/store';
import { COMMON as commonCy } from '@orderez/qa-utils/dist/orderEz/common';

export default {
  components: {
    EzButton,
    EzButtonDropdown,
  },
  props: {
    /**
     * This attribute is used for
     * marking the element when testing with cypress
     */
    dataCy: {
      required: false,
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: false,
      commonCy,
    };
  },
  computed: {
    ...mapState('entities/users', ['loggedUser']),
    legal() {
      const role = localStorage.getItem('role');

      if (role === 'venue') {
        return 'venue-legal';
      }

      return 'distributor-legal';
    },
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    onLogoutClick() {
      this.managerLogout().finally(() => {
        const logInMethod = localStorage.getItem('logInMethod');
        localStorage.clear();
        localStorage.setItem('logInMethod', logInMethod);
        resetState();
        window.Intercom('shutdown');
        this.$router.replace({ name: 'platform-login' });
      });
    },
    openHelp() {
      let { helpUrl } = this.loggedUser;
      if (!helpUrl) {
        helpUrl = process.env.VUE_APP_HELP_LINK;
      }
      window.open(helpUrl, '_blank');
    },
    ...mapActions('entities/users', ['managerLogout']),
    ...mapMutations('entities/users', ['SWITCH_CONTEXT']),
    ...mapMutations('cart', ['EMPTY_CART']),
  },
};
</script>

<style scoped lang="scss">
:deep() .button-dropdown {
  &__toggle-container {
    .entity-info__text {
      max-width: 10rem;

      span {
        display: inline-block;
        overflow-x: hidden;
        line-height: 1.6;
        text-overflow: ellipsis;
      }
    }

    .button {
      &:last-child {
        padding-right: 0;
        padding-left: 0;
      }
    }
  }

  &__dropdown {
    width: 15rem;
    padding: 0.25rem 0;
    max-height: calc(100dvh - 60px);
    overflow: auto;

    .dropdown-section {
      &__label {
        @extend %gray-label;
        @include font-size(11px, 13px);
        font-weight: 600;
        letter-spacing: 0.15px;
        text-transform: uppercase;
        margin: 0.5rem 0;
        padding: 0 0.75rem;
      }

      &:first-child {
        padding-top: 0;
      }

      &:last-child {
        padding-bottom: 0;
      }

      hr {
        @include separator('bottom', 0.25rem, 0.25rem, 1px solid #dee1e4);
        margin-left: 0.75rem;
        margin-right: 0.75rem;
      }
    }

    .context-section {
      .dropdown-section__label {
        margin-top: 1rem;
      }
    }

    .button--link {
      @include font-size(14px, 16px);
      display: block;
      padding: 0.625rem 0.75rem;
      color: $color-gray-25;
      font-weight: 400;
      text-align: left;
      text-decoration: none;

      &:hover {
        background-color: $color-gray-F5;
        cursor: pointer;
      }

      &.gray-link {
        color: $color-gray-6C;
      }
    }

    .entity-info {
      margin: 0.25rem 0.75rem;

      &__text {
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-around;
      }

      a {
        @extend %flex-center;
        @include font-size(12px, 14px);
        color: $color-gray-6C;
        text-decoration: none;
        font-weight: 400;

        span {
          margin-right: 0.25rem;
        }

        svg {
          @include font-size(12px);
        }
      }
    }
  }
}
</style>
